import { put, takeEvery } from 'redux-saga/effects';
import { setDataSuccess } from './actions';

function* setData(action) {
  try {
    console.log("action:::::::: " ,action)
    // Handle the action and store the data
    const data = action.payload;
    yield put(setDataSuccess(data));
  } catch (error) {
    // Handle any errors
  }
}

function* rootSaga() {
  yield takeEvery('SET_DATA', setData);
}

export default rootSaga;